import Login from "../pages/Login/Login";
import Directory from "../pages/Directory/Directory";
import Applications from "../pages/Applications";
import ApplicationInfo from "../pages/ApplicationInfo";
import DirectoryInfo from "../pages/Directory/DirectoryInfo";
import Channels from "../pages/Channels";
import ChannelInfo from "../components/Channels/ChannelInfo";
import ChannelCreate from "../pages/ChannelCreate";
import Private from "../layout/Private";
import Public from "../layout/Public";
import ChannelApplications from "../components/Channels/ChannelApplications";
import ChannelApplicationsDetails from "../components/Channels/ChannelApplicationsDetails";
import UpdateDefaultConfiguration from "../components/Application/UpdateDefaultConfiguration";
import DefaultEnvironmentVariable from "../components/Application/DefaultEnvironmentVariable";
import Groups from "../pages/Groups";
import GroupList from "../pages/GroupList";
import CreateGroup from "../pages/CreateGroup";
import DirectoryApplicationDetail from "../pages/Directory/DirectoryApplicationDetail";

export const routes = {
  private: [
    {
      path: "/dashboard/applications",
      elem: Applications,
      layout: Private,
    },
    {
      path: "/dashboard/application/update/configuration/:appId/:id",
      elem: DefaultEnvironmentVariable,
      layout: Private,
    },
    {
      path: "/dashboard/applications/info/:uuid",
      elem: ApplicationInfo,
      layout: Private,
    },
    {
      path: "/dashboard/directories",
      elem: Directory,
      layout: Private,
    },
    {
      path: "/dashboard/directories/info/:id",
      elem: DirectoryInfo,
      layout: Private,
    },
    {
      path: "/dashboard/directories/application/:directoryId/:applicationId",
      elem: DirectoryApplicationDetail,
      layout: Private,
    },
    {
      path: "/dashboard/channels/application/list/:id",
      elem: ChannelInfo,
      layout: Private,
    },
    {
      path: "/dashboard/directories/channel/application/list/:id",
      elem: ChannelInfo,
      layout: Private,
    },
    {
      path: "/dashboard/channels/applications/details/:channelId/:applicationId",
      elem: ChannelApplicationsDetails,
      layout: Private,
    },
    {
      path: "/dashboard/directories/channel/applications/details/:channelId/:applicationId",
      elem: ChannelApplicationsDetails,
      layout: Private,
    },
    {
      path: "/dashboard/channels",
      elem: Channels,
      layout: Private,
    },
    {
      path: "/dashboard/channels/info/:id",
      elem: ChannelInfo,
      layout: Private,
    },
    {
      path: "/dashboard/channels/create",
      elem: ChannelCreate,
      layout: Private,
    },
    {
      path: "/dashboard/groups/list",
      elem: GroupList,
      layout: Private,
    },
    {
      path: "/dashboard/groups/list/create-group",
      elem:CreateGroup,
      layout: Private,
    },
  ],
  public: [
    {
      path: "/gateway",
      elem: Login,
      layout: Public,
    },
  ],
};
